import { getMenuList } from './auth'

/**
 * 获取所有权限的菜单代码列表
 */
export function getPermissionCodes() {
  const menuList = getMenuList()
  if (!menuList || !Array.isArray(menuList)) {
    return []
  }

  const codes = []

  // 递归提取所有 menuCode
  function extractCodes(menus) {
    menus.forEach(menu => {
      if (menu.menuCode) {
        codes.push(menu.menuCode)
      }
      if (menu.children && menu.children.length > 0) {
        extractCodes(menu.children)
      }
    })
  }

  extractCodes(menuList)
  return codes
}

/**
 * 检查是否有某个权限
 * @param {string} permissionCode - 权限代码，如 'sysUser.manage.update'
 * @returns {boolean}
 */
export function hasPermission(permissionCode) {
  const codes = getPermissionCodes()
  console.log(codes);
  const hasAuth = codes.includes(permissionCode)
  return hasAuth
}

/**
 * 检查是否有任意一个权限
 * @param {string[]} permissionCodes - 权限代码数组
 * @returns {boolean}
 */
export function hasAnyPermission(permissionCodes) {
  const codes = getPermissionCodes()
  return permissionCodes.some(code => codes.includes(code))
}

/**
 * 检查是否有所有权限
 * @param {string[]} permissionCodes - 权限代码数组
 * @returns {boolean}
 */
export function hasAllPermissions(permissionCodes) {
  const codes = getPermissionCodes()
  return permissionCodes.every(code => codes.includes(code))
}
